module.exports = __webpack_public_path__ + "lg-4fe6f9caff8b287170d51d3d71d5e5c6.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/lightgallery/dist/fonts/lg.ttf
// module id = 915
// module chunks = 124